import {ComparisonArrow, getTimePeriod, handleTip, humanizeTime} from "./utils";
import React from "react";

function AverageDelivery({data, term}) {
    const activeTab = term === 0 ? "Year" : term === 1 ? "Quarter" : "Month"

    const avgDeliveryTime = Object.entries(data).reverse().slice(0, 2).map(([key, value]) =>
        Number.parseFloat((value.reduce((prev, curr) =>
                prev + (curr.delivered_on ? Math.abs(new Date(curr.delivered_on) - new Date(curr.order_date)) : 0), 0)
            / value.length).toFixed(2)));

    if (avgDeliveryTime)
        return <div id={"avgDel"} className={"col-span-2 card flex flex-1"}>
            <div
                className={"h-fit whitespace-nowrap flex flex-1 items-center justify-between"}>
                <div className={"flex flex-col item-start"}>
                    <div className={"flex items-center justify-between gap-2 relative"}>
                        <span className={"font-bold text-gray-800 text-md"}>Average Delivery Time</span>

                        <div onMouseEnter={(e) => handleTip(e, "avgDel")}
                             onMouseLeave={(e) => handleTip(e, "avgDel")}
                             className={"show-tip"}>
                            <span className={"material-symbols-rounded text-md"}>info</span>
                            <div
                                className={"tool-tip-cover"}>
                            <span
                                className={"p-2 block px-4 whitespace-normal text-sm w-[20rem]"}>{`The average time required by the deliver orders over ${activeTab} (${getTimePeriod(activeTab)})`}</span>
                            </div>
                        </div>
                    </div>
                    <span
                        className={"text-xs text-gray-600"}>This {activeTab}</span>
                </div>

                <div className={"flex items-end gap-1"}>
                    <span
                        className={"font-extrabold text-2xl"}>{humanizeTime(avgDeliveryTime[0] || 0)}</span>
                    <ComparisonArrow one={avgDeliveryTime[0] / 1000}
                                     prefix={""}
                                     suffix={" seconds"}
                                     two={avgDeliveryTime[1] / 1000}/>
                </div>
            </div>
        </div>
}

export default AverageDelivery;